import { useMemo } from 'react';

import { Box } from '@cast/design-system';
import {
  DailyComputeSpendTable,
  isStorageReportsSupported,
} from '@cast/split-me/features/cluster/cost-report';
import { FailedToLoad } from '@cast/shared-messages-ui';

import { inventoryWorkloadTableKeys, tableCacheKeys } from '../../consts';

import { useCluster } from '@cast/shared-cluster-context-data-access';

import { DateRangeUnsupportedBanner } from '../dashboard/_components/DateRangeUnsupportedBanner';

import { useInventoryWorkloadComputeData } from './_hooks';

export const InventoryWorkloadListCompute = () => {
  const { data, isLoading, error, isRangeSupported } =
    useInventoryWorkloadComputeData();
  const { cluster } = useCluster();

  const hasGpuData = useMemo(
    () =>
      data.some((row) => row.countGpu.total > 0 || row.totalUptimeGpuCost > 0),
    [data]
  );

  const hasTpuData = useMemo(
    () =>
      data.some((row) => row.countTpu.total > 0 || row.totalUptimeTpuCost > 0),
    [data]
  );

  const showStorage = isStorageReportsSupported(cluster);

  if (!isRangeSupported) {
    return (
      <Box mt={24}>
        <DateRangeUnsupportedBanner testId="inventory-workload-compute-unsupported-range" />
      </Box>
    );
  }

  if (error) {
    return (
      <Box mt={24}>
        <FailedToLoad title="Failed to load workload compute details" />
      </Box>
    );
  }

  return (
    <DailyComputeSpendTable
      data={data}
      isLoading={isLoading}
      hasGpuData={hasGpuData}
      hasTpuData={hasTpuData}
      showStorage={showStorage}
      cacheKey={tableCacheKeys.INVENTORY_WORKLOAD.COMPUTE}
      urlKey={inventoryWorkloadTableKeys.COMPUTE}
      testId="inventory-workload-compute-table"
    />
  );
};
